document.addEventListener("DOMContentLoaded", () => {
  populateRadioList("unitListFrom", unitList, "fromUnit");
  populateRadioList("unitListTo", unitList, "toUnit");
});

const unitList = [
  "milliliter ( ml )",
  "liter ( L )",
  "tablespoon ( Tbsp – tbls )",
  "teaspoon ( tsp – tspn )",
  "ounce ( oz )",
  "fluid ounce ( fl oz )",
  "cup US",
  "gram ( g )",
  "kilogram ( kg – kilo )",
  "cup Metric",
  "pound ( lb )",
  "pint US ( pt )",
  "pint UK ( pt )",
  "quart US ( qt )",
  "gallon US ( gal )",
  "US Legal Nutrition labeling cup ( = 240ml )",
  "100ml serve",
  "deciliter ( dl – dcl )",
  "dekagram ( dkg – deca – deka )",
  "drop ( 1/20 ml/drop )",
  // "kilojoules ( kJ ) energy",
  // "calories ( Cal ) energy",
  // "Protein – gram ( g )",
  // "Fat, total – gram ( g )",
  // "– Saturated Fat – gram ( g )",
  // "– Trans fatty acids – gram ( g )",
  // "– Polyunsaturated Fat – gram ( g )",
  // "– Monounsaturated Fat – gram ( g )",
  // "Cholesterol – milligram ( mg )",
  // "Total Carbohydrates – gram ( g )",
  // "– Sugars – gram ( g )",
  // "Dietary Fiber – gram ( g )",
  // "Sodium in light olive oil – milligrams ( mg )",
  // "Vitamin E in light olive oil – milligram ( mg )",
];

const units = {
  "cup Metric": { type: "volume", toBase: 0.25 },
  "cup US": { type: "volume", toBase: 0.236588 },
  "fluid ounce ( fl oz ) of light olive oil": {
    type: "volume",
    toBase: 0.0295735,
  },
  "gallon US ( gal )": { type: "volume", toBase: 3.78541 },
  "pint US ( pt )": { type: "volume", toBase: 0.473176 },
  "pint UK ( pt )": { type: "volume", toBase: 0.568261 },
  "quart US ( qt )": {
    type: "volume",
    toBase: 0.946353,
  },
  "milliliter ( ml )": { type: "volume", toBase: 0.001 },
  "deciliter ( dl – dcl )": { type: "volume", toBase: 0.1 },
  "liter ( L )": { type: "volume", toBase: 1 },
  "tablespoon ( Tbsp – tbls )": {
    type: "volume",
    toBase: 0.0147868,
  },
  "teaspoon ( tsp – tspn )": {
    type: "volume",
    toBase: 0.00492892,
  },
  "drop ( 1/20 ml/drop )": {
    type: "volume",
    toBase: 0.00005,
  },
  "100ml serve": { type: "volume", toBase: 0.1 },
  "US Legal Nutrition labeling cup ( = 240ml )": {
    type: "volume",
    toBase: 0.24,
  },

  "ounce ( oz )": { type: "mass", toBase: 28.3495 },
  "pound ( lb )": { type: "mass", toBase: 453.592 },
  "gram ( g )": { type: "mass", toBase: 1 },
  "dekagram ( dkg – deca – deka )": { type: "mass", toBase: 10 },
  "kilogram ( kg – kilo )": { type: "mass", toBase: 1000 },

  "kilojoules ( kJ )": { type: "energy", toBase: 37 },
  "calories ( Cal )": { type: "energy", toBase: 8.84 },

  // ask if nutrition values are correct
  "Protein – gram ( g )": {
    type: "nutrition",
    toBase: 0,
    nutrient: "protein",
  },
  "Fat, total – gram ( g )": {
    type: "nutrition",
    toBase: 1,
    nutrient: "fat",
  },
  "– Saturated Fat – gram ( g )": {
    type: "nutrition",
    toBase: 0.14,
    nutrient: "saturatedFat",
  },
  "– Trans fatty acids – gram ( g )": {
    type: "nutrition",
    toBase: 0,
    nutrient: "transFat",
  },
  "– Polyunsaturated Fat – gram ( g )": {
    type: "nutrition",
    toBase: 0.11,
    nutrient: "polyunsaturatedFat",
  },
  "– Monounsaturated Fat – gram ( g )": {
    type: "nutrition",
    toBase: 0.73,
    nutrient: "monounsaturatedFat",
  },
  "Cholesterol – milligram ( mg )": {
    type: "nutrition",
    toBase: 0,
    nutrient: "cholesterol",
  },
  "Total Carbohydrates – gram ( g )": {
    type: "nutrition",
    toBase: 0,
    nutrient: "carbohydrates",
  },
  "– Sugars – gram ( g )": {
    type: "nutrition",
    toBase: 0,
    nutrient: "sugars",
  },
  "Dietary Fiber – gram ( g )": {
    type: "nutrition",
    toBase: 0,
    nutrient: "fiber",
  },
  "Sodium in light olive oil – milligrams ( mg )": {
    type: "nutrition",
    toBase: 0,
    nutrient: "sodium",
  },
  "Vitamin E in light olive oil – milligram ( mg )": {
    type: "nutrition",
    toBase: 0.00014,
    nutrient: "vitaminE",
  },
};

const nutritionPerGram = {
  energy_kJ_per_g: 37, // 3700 kJ per 100g
  energy_Cal_per_g: 8.84, // 884 Cal per 100g
  fat_per_g: 1, // 100g per 100g
  saturatedFat_per_g: 0.14, // 14g per 100g
  transFat_per_g: 0, // 0g per 100g
  polyunsaturatedFat_per_g: 0.11, // 11g per 100g
  monounsaturatedFat_per_g: 0.73, // 73g per 100g
  cholesterol_per_g: 0, // mg per gram
  protein_per_g: 0, // 0g per 100g
  carbohydrates_per_g: 0, // 0g per 100g
  sugars_per_g: 0, // 0g per 100g
  fiber_per_g: 0, // 0g per 100g
  sodium_per_g: 0, // mg per gram
  vitaminE_per_g: 0.00014, // 14 mg per 100g
};

// previous tool uses 0.905
const density = 0.918; // grams per milliliter

function populateRadioList(containerId, items, groupName) {
  const container = document.getElementById(containerId);
  items.forEach((item, index) => {
    const radioWrapper = document.createElement("div");
    radioWrapper.classList.add("radio-item");

    const radio = document.createElement("input");
    radio.type = "radio";
    radio.id = `${containerId}-item-${index}`;
    radio.name = groupName;
    radio.value = item;

    const label = document.createElement("label");
    label.htmlFor = radio.id;
    label.textContent = item;

    radioWrapper.appendChild(radio);
    radioWrapper.appendChild(label);
    container.appendChild(radioWrapper);
  });
}

function convertSameType(value, fromUnit, toUnit) {
  const from = units[fromUnit];
  const to = units[toUnit];

  const baseValue = value * from.toBase;

  const convertedValue = baseValue / to.toBase;

  return convertedValue;
}

function convertMassToVolume(value, fromUnit, toUnit) {
  const from = units[fromUnit];
  const to = units[toUnit];

  const massInGrams = value * from.toBase;
  const volumeInMilliliters = massInGrams / density;
  const volumeInLiters = volumeInMilliliters / 1000;
  const convertedValue = volumeInLiters / to.toBase;

  return convertedValue;
}

function convertVolumeToMass(value, fromUnit, toUnit) {
  const from = units[fromUnit];
  const to = units[toUnit];

  const volumeInLiters = value * from.toBase;
  const volumeInMilliliters = volumeInLiters * 1000;
  const massInGrams = volumeInMilliliters * density;
  const convertedValue = massInGrams / to.toBase;

  return convertedValue;
}

function convertMassToEnergy(value, fromUnit, toUnit) {
  const from = units[fromUnit];
  const to = units[toUnit];
  let massInGrams;

  massInGrams = value * from.toBase;

  if (toUnit === "kilojoules ( kJ ) energy") {
    const energy = massInGrams * nutritionPerGram.energy_kJ_per_g;
    return energy;
  } else if (toUnit === "calories ( Cal ) energy") {
    const energy = massInGrams * nutritionPerGram.energy_Cal_per_g;
    return energy;
  } else {
    throw new Error("Unknown energy unit.");
  }
}

function convertVolumeToEnergy(value, fromUnit, toUnit) {
  const from = units[fromUnit];
  const to = units[toUnit];
  let massInGrams;

  const volumeInLiters = value * from.toBase;
  const volumeInMilliliters = volumeInLiters * 1000;
  massInGrams = volumeInMilliliters * density;

  if (toUnit === "kilojoules ( kJ ) energy") {
    const energy = massInGrams * nutritionPerGram.energy_kJ_per_g;
    return energy;
  } else if (toUnit === "calories ( Cal ) energy") {
    const energy = massInGrams * nutritionPerGram.energy_Cal_per_g;
    return energy;
  } else {
    throw new Error("Unknown energy unit.");
  }
}

function convertEnergyToVolume(value, fromUnit, toUnit) {
  const from = units[fromUnit];
  const to = units[toUnit];
  let massInGrams;

  if (fromUnit === "kilojoules ( kJ ) energy") {
    massInGrams = value / nutritionPerGram.energy_kJ_per_g;
  } else if (fromUnit === "calories ( Cal ) energy") {
    massInGrams = value / nutritionPerGram.energy_Cal_per_g;
  } else {
    throw new Error("Unknown energy unit.");
  }

  const volumeInMilliliters = massInGrams / density;
  const volumeInLiters = volumeInMilliliters / 1000;
  const convertedValue = volumeInLiters / to.toBase;
  return convertedValue;
}

function convertEnergyToMass(value, fromUnit, toUnit) {
  const from = units[fromUnit];
  const to = units[toUnit];
  let massInGrams;

  if (fromUnit === "kilojoules ( kJ ) energy") {
    massInGrams = value / nutritionPerGram.energy_kJ_per_g;
  } else if (fromUnit === "calories ( Cal ) energy") {
    massInGrams = value / nutritionPerGram.energy_Cal_per_g;
  } else {
    throw new Error("Unknown energy unit.");
  }

  const convertedValue = massInGrams / to.toBase;
  return convertedValue;
}

function convertMassToNutrition(value, fromUnit, toUnit) {
  const from = units[fromUnit];
  const to = units[toUnit];
  let massInGrams;

  massInGrams = value * from.toBase;
  const nutrient = units[toUnit].nutrient;
  const nutrientPerGram = nutritionPerGram[nutrient + "_per_g"];

  if (toUnit.includes("milligram ( mg )")) {
    const nutrientAmount = massInGrams * nutrientPerGram * 1000;
    return nutrientAmount;
  } else {
    const nutrientAmount = massInGrams * nutrientPerGram;
    return nutrientAmount;
  }
}

function convertVolumeToNutrition(value, fromUnit, toUnit) {
  const from = units[fromUnit];
  const to = units[toUnit];
  let massInGrams;

  const volumeInLiters = value * from.toBase;
  const volumeInMilliliters = volumeInLiters * 1000;
  massInGrams = volumeInMilliliters * density;

  const nutrient = units[toUnit].nutrient;
  const nutrientPerGram = nutritionPerGram[nutrient + "_per_g"];

  if (nutrientPerGram === undefined) {
    throw new Error("Nutrient data not available.");
  }

  let nutrientAmount = massInGrams * nutrientPerGram;

  if (toUnit.includes("milligram ( mg )")) {
    nutrientAmount *= 1000;
  }

  return nutrientAmount;
}

function convertNutritionToMass(value, fromUnit, toUnit) {
  const from = units[fromUnit];
  const to = units[toUnit];
  let nutrientAmount;

  if (fromUnit.includes("milligram ( mg )")) {
    nutrientAmount = value / 1000;
  } else {
    nutrientAmount = value;
  }

  const nutrient = units[fromUnit].nutrient;
  const nutrientPerGram = nutritionPerGram[nutrient + "_per_g"];

  if (nutrientPerGram === undefined || nutrientPerGram === 0) {
    throw new Error("Cannot convert from this nutrient to mass/volume.");
  }

  const massInGrams = nutrientAmount / nutrientPerGram;
  const convertedValue = massInGrams / to.toBase;
  return convertedValue;
}

function convertNutritionToVolume(value, fromUnit, toUnit) {
  const from = units[fromUnit];
  const to = units[toUnit];
  let nutrientAmount;

  if (fromUnit.includes("milligram ( mg )")) {
    nutrientAmount = value / 1000;
  } else {
    nutrientAmount = value;
  }

  const nutrient = units[fromUnit].nutrient;
  const nutrientPerGram = nutritionPerGram[nutrient + "_per_g"];

  if (nutrientPerGram === undefined || nutrientPerGram === 0) {
    throw new Error("Cannot convert from this nutrient to mass/volume.");
  }

  const massInGrams =
    nutrientAmount / (nutrientPerGram / nutritionPerGram["fat_per_g"]);

  const volumeInMilliliters = massInGrams / density;
  const volumeInLiters = volumeInMilliliters / 1000;
  const convertedValue = volumeInLiters / to.toBase;
  return convertedValue;
}

function convertNutritionToEnergy(value, fromUnit, toUnit) {
  let nutrientAmount;

  const energyPerGramNutrient = {
    protein: 17,
    carbohydrates: 17,
    fat: 37,
    saturatedFat: 37,
    transFat: 37,
    polyunsaturatedFat: 37,
    monounsaturatedFat: 37,
  };
  const nutrient = units[fromUnit].nutrient;
  const energyPerGram = energyPerGramNutrient[nutrient];

  if (energyPerGram === undefined) {
    throw new Error("Cannot convert this nutrient to energy.");
  }

  if (fromUnit.includes("milligram ( mg )")) {
    nutrientAmount = value / 1000;
  } else {
    nutrientAmount = value;
  }

  const energyInKJ = nutrientAmount * energyPerGram;

  if (toUnit === "kilojoules ( kJ ) energy") {
    return energyInKJ;
  } else if (toUnit === "calories ( Cal ) energy") {
    return energyInKJ / 4.184;
  } else {
    throw new Error("Unknown energy unit.");
  }
}

function convertEnergyToNutrition(value, fromUnit, toUnit) {
  const nutrient = units[toUnit].nutrient;

  const energyPerGramFat = 37; // kJ/g for fat

  let energyInKJ;

  // Convert the input energy to kilojoules if necessary
  if (fromUnit === "kilojoules ( kJ ) energy") {
    energyInKJ = value;
  } else if (fromUnit === "calories ( Cal ) energy") {
    energyInKJ = value * 4.184; // 1 Cal = 4.184 kJ
  } else {
    throw new Error("Unknown energy unit.");
  }

  // Calculate total fat in grams
  const totalFatInGrams = energyInKJ / energyPerGramFat;

  // Get the proportion of the nutrient in olive oil
  const proportion =
    nutritionPerGram[nutrient + "_per_g"] / nutritionPerGram["fat_per_g"];

  if (proportion === undefined || isNaN(proportion)) {
    throw new Error("Cannot convert energy to this nutrient.");
  }

  // Calculate the nutrient amount in grams
  const nutrientAmountInGrams = totalFatInGrams * proportion;

  // If the nutrient unit is in milligrams, convert grams to milligrams
  if (toUnit.includes("milligram ( mg )")) {
    return nutrientAmountInGrams * 1000;
  } else {
    return nutrientAmountInGrams;
  }
}

function convertUnits(value, fromUnit, toUnit) {
  const from = units[fromUnit];
  const to = units[toUnit];

  if (from.type === to.type) {
    return convertSameType(value, fromUnit, toUnit);
  }
  if (from.type === "mass" && to.type === "volume") {
    return convertMassToVolume(value, fromUnit, toUnit);
  }

  if (from.type === "mass" && to.type === "energy") {
    return convertMassToEnergy(value, fromUnit, toUnit);
  }

  if (from.type === "mass" && to.type === "nutrition") {
    return convertMassToNutrition(value, fromUnit, toUnit);
  }

  if (from.type === "volume" && to.type === "mass") {
    return convertVolumeToMass(value, fromUnit, toUnit);
  }

  if (from.type === "volume" && to.type === "nutrition") {
    return convertVolumeToNutrition(value, fromUnit, toUnit);
  }

  if (from.type === "volume" && to.type === "energy") {
    return convertVolumeToEnergy(value, fromUnit, toUnit);
  }

  if (from.type === "energy" && to.type === "mass") {
    return convertEnergyToMass(value, fromUnit, toUnit);
  }

  if (from.type === "energy" && to.type === "volume") {
    return convertEnergyToVolume(value, fromUnit, toUnit);
  }

  if (from.type === "energy" && to.type === "nutrition") {
    return convertEnergyToNutrition(value, fromUnit, toUnit);
  }

  if (from.type === "nutrition" && to.type === "mass") {
    return convertNutritionToMass(value, fromUnit, toUnit);
  }

  if (from.type === "nutrition" && to.type === "volume") {
    return convertNutritionToVolume(value, fromUnit, toUnit);
  }

  if (from.type === "nutrition" && to.type === "energy") {
    return convertNutritionToEnergy(value, fromUnit, toUnit);
  }
}

function performConversion() {
  // Get the amount entered
  const amtInput = document.getElementById("amt").value.trim();
  let value;
  try {
    value = parseFraction(amtInput);
  } catch (error) {
    alert("Please enter a valid amount.");
    return;
  }

  // Get precision
  let precision = parseInt(document.getElementById("precision").value);
  if (isNaN(precision) || precision < 0 || precision > 9) {
    precision = 2; // Default precision
  }

  // Get selected "from" unit
  const fromRadios = document.getElementsByName("fromUnit");
  let fromUnit = null;
  for (const radio of fromRadios) {
    if (radio.checked) {
      fromUnit = radio.value;
      break;
    }
  }
  if (!fromUnit) {
    alert("Please select a unit to convert from.");
    return;
  }

  // Get selected "to" unit
  const toRadios = document.getElementsByName("toUnit");
  let toUnit = null;
  for (const radio of toRadios) {
    if (radio.checked) {
      toUnit = radio.value;
      break;
    }
  }
  if (!toUnit) {
    alert("Please select a unit to convert to.");
    return;
  }

  // Perform the conversion
  try {
    const result = convertUnits(value, fromUnit, toUnit);
    const resultFormatted = parseFloat(result.toFixed(precision));

    // Display the result
    const resultDiv = document.getElementById("result");
    resultDiv.innerHTML = `<strong>${value}</strong> ${fromUnit} is equal to <strong>${resultFormatted}</strong> ${toUnit}`;
  } catch (error) {
    alert(error.message);
  }
}

function parseFraction(value) {
  value = value.trim();
  if (value.includes("/")) {
    // Handle fractions
    const parts = value.split(" ");
    let fraction;
    if (parts.length === 2) {
      // Mixed number (e.g., "3 1/2")
      const wholeNumber = parseFloat(parts[0]);
      const fractionParts = parts[1].split("/");
      if (fractionParts.length !== 2) throw new Error("Invalid fraction");
      const numerator = parseFloat(fractionParts[0]);
      const denominator = parseFloat(fractionParts[1]);
      fraction = wholeNumber + numerator / denominator;
    } else if (parts.length === 1) {
      // Simple fraction (e.g., "1/2")
      const fractionParts = parts[0].split("/");
      if (fractionParts.length !== 2) throw new Error("Invalid fraction");
      const numerator = parseFloat(fractionParts[0]);
      const denominator = parseFloat(fractionParts[1]);
      fraction = numerator / denominator;
    } else {
      throw new Error("Invalid fraction");
    }
    return fraction;
  } else {
    // Handle decimals and integers
    const number = parseFloat(value);
    if (isNaN(number)) throw new Error("Invalid number");
    return number;
  }
}

// Reset button logic
document.getElementById("reset").addEventListener("click", () => {
  document.getElementById("amt").value = "";
  document.getElementById("precision").value = "2";

  const fromRadios = document.getElementsByName("fromUnit");
  const toRadios = document.getElementsByName("toUnit");

  fromRadios.forEach((radio) => {
    radio.checked = false;
  });

  toRadios.forEach((radio) => {
    radio.checked = false;
  });

  document.getElementById("result").textContent = "0";
});
